'use strict';

var path = require('path');

var Module = require('module');

var resolveFrom = function resolveFrom(fromDir, moduleId, silent) {
  if (typeof fromDir !== 'string') {
    throw new TypeError("Expected `fromDir` to be of type `string`, got `".concat(typeof fromDir, "`"));
  }

  if (typeof moduleId !== 'string') {
    throw new TypeError("Expected `moduleId` to be of type `string`, got `".concat(typeof moduleId, "`"));
  }

  fromDir = path.resolve(fromDir);
  var fromFile = path.join(fromDir, 'noop.js');

  var resolveFileName = function resolveFileName() {
    return Module._resolveFilename(moduleId, {
      id: fromFile,
      filename: fromFile,
      paths: Module._nodeModulePaths(fromDir)
    });
  };

  if (silent) {
    try {
      return resolveFileName();
    } catch (err) {
      return null;
    }
  }

  return resolveFileName();
};

module.exports = function (fromDir, moduleId) {
  return resolveFrom(fromDir, moduleId);
};

module.exports.silent = function (fromDir, moduleId) {
  return resolveFrom(fromDir, moduleId, true);
};